import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../../../../api/ajax-endpoints";
import { getData } from "../../../../../../../newApis/dotNetApiMethods";
import { IPaginatedResponse } from "../../../../../../../interfaces/response";

export type TApproverData = {
    numberOfSignatories: number;
    status: string;
    batchReference: string;
    signatoryRequestDetails: {
        requestedNumberOfSignatories: number;
        requestedNumberOfSignatoryStatus: string;
    };
};

const getSetupApprovers = async ({ customerId }: { customerId: number }) => {
    const response = await getData(
        `${ajaxEndpoints.GET_SIGNATORY_SETUP}?customerId=${customerId}`
    );
    return response.data;
};


export default function useGetApprover({
    customerId,
}: {
    customerId: number;
}) {
    return useQuery<IPaginatedResponse<TApproverData>>(
        [{ customerId }, "getSetupApprovers"],
        getSetupApprovers,
        {
            refetchOnWindowFocus: false,
        }
    );
}
